// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"da74207f","25":"0fb429f9","213":"d4cbbed4","403":"fd8e6b85","514":"88832f24","575":"57fdd0cd","672":"20a32926","703":"32144800","825":"fdad5d81"}[chunkId] + ".chunk.css";
};